// TODO: replace with EXTERNAL_ROUTES.PROPERTIES
const RENTAL_MANAGER_PROPERTIES_REFERRER_PATH = 'rental-manager/properties';
const CREATE_LISTING_REFERRER_PATH = '/create-listing';

const isPropertiesPathReferrer = (referrer: string) =>
  referrer.includes(RENTAL_MANAGER_PROPERTIES_REFERRER_PATH) && !referrer.includes(CREATE_LISTING_REFERRER_PATH);

/**
 * Shows the Overview back button when navigation came from Rental Manager properties
 * outside the create-listing wizard. Referrers from another create-listing step or a refresh
 * (empty referrer) keep the back button hidden.
 */
const useMultiplexOverviewBackButtonVisibility = () => {
  const shouldShowBackButton = typeof document !== 'undefined' && isPropertiesPathReferrer(document.referrer);

  return shouldShowBackButton;
};

export default useMultiplexOverviewBackButtonVisibility;
export { CREATE_LISTING_REFERRER_PATH, isPropertiesPathReferrer, RENTAL_MANAGER_PROPERTIES_REFERRER_PATH };
